// Web stand-in for react-native-view-shot (aliased in
// webpack.config.web.js). TonyteCropModal's native "screenshot the crop
// frame" approach doesn't apply on web — a Canvas-based crop (drawing the
// already-decoded <img> onto a canvas at the selected crop rect) is the
// real web equivalent, and is Phase 1 follow-up work since image
// upload/crop isn't part of the Phase 0 login-flow proof. This stub throws
// a clear, visible error instead of returning a fake URI.
export async function captureRef(_ref: unknown, _options?: unknown): Promise<never> {
  throw new Error('[Tonyte][Web] Image cropping is not implemented on web yet (Phase 0).');
}

export default captureRef;
